import { createI18n } from "vue-i18n";

const messages = {
  en: {
    sendOtp: "ارسال رمز یکبار مصرف",
    signInWithOtp: "ورود با رمز یکبار مصرف",
    enter_one_of_the_prices: "حداقل یکی از قیمت هارا وارد نمایید",
    required_image: "انتخاب عکس الزامی می باشد",
    mobileOrEmail: "موبایل یا ایمیل",
    mobile: "موبایل",
    email: "ایمیل",
    signIn: "ورود به حساب کاربری",
    password: "رمز عبور",
    login: "ورود",
    pleaseWait: "لطفا منتظر بمانید...",
    tryAgain: "دوباره تلاش کنید",
    required: "وارد کردن این فیلد اجباری است",
    exist: "خروج",
    notExist: "ناموجود",
    noRecordFound: "اطلاعاتی یافت نشد",
    otp: "کد ارسال شده",
    CreateAnAccount: "ایجاد حساب کاربری",
    AlreadyHaveAnAccount: "حساب کاربری دارید؟",
    SignInHere: "ورود به حساب کاربری",
    fullName: "نام و نام خانوادگی",
    companyName: "شرکت",
    passwordTooltip:
      "رمزعبور قوی شامل 8 کارکتر، حروف کوچک و بزرگ، اعداد، کارکترهای خاص است",
    ConfirmPassword: "تکرار رمزعبور",
    singUp: "ثبت نام",
    PasswordsMustMatch: "تکرار رمزعبور صحیح نیست",
    otp_min: "کد ارسالی 4 رقمی است",
    invalidEmail: "ایمیل به درستی وارد نشده است",
    activeMobile: "تایید شماره همراه",
    accept: "تایید",
    acceptRoles: "باید قوانین و مقررات را بپذیرید",
    sendCode: "ارسال کد",
    servicesPackage: "سرویس ها",
    servicesList: "لیست سرویس ها",
    addService: "اضافه کردن سرویس",
    editService: "ویرایش سرویس",
    title: "عنوان",
    active: "فعال",
    deactivate: "غیر فعال",
    created_at: "تاریخ ایجاد",
    actions: "عملیات",
    name: "نام",
    searchTxt: "جستجو",
    search: "جستجو",
    back: "بازگشت",
    type: "نوع",
    all: "همه",
    filterByType: "فیلتر بر اساس نوع",
    selectImage: "انتخاب عکس",
    price_usd: "قیمت به دلار",
    price_aed: "قیمت به درهم",
    activeOrDeactivate: "فعال / غیر فعال",
    price_usd_tooltip:
      "برای هر سرویس فقط قیمت دلار یا فقط قیمت درهم را وارد کنید در غیر اینصورت قیمت دلار محاسبه می شود",
    settings: "تنظیمات",
    range_price: "رنج قیمت دلار و درهم",
    from: "از",
    to: "تا",
    percent_or_price: "درصد یا مبلغ",
    percent: "درصد",
    cash: "مبلغ",
    save: "ذخیره",
    range_aed: "رنج قیمت برای درهم",
    range_usd: "رنج قیمت برای دلار",

    name_en: "English",
    name_ne: "Netherlands",
    question_en: "Question English",
    question_ne: "Question Netherlands",
    dragDropOne: "Drag & drop with one correct answer",
    dragDropMulti: "Drag & drop with multiple correct answers",
    radiobox: "Multiple answer with one correct answer",
    checkbox: "Multiple answer with multiple correct answer",
    blankOne: "Blank type one",
    blankTwo: "Blank type two",
    explain_en: "Explain English",
    explain_ne: "Explain Netherlands",
    selectImageForQuestion: "Select image for question",
    selectSoundForQuestion_en: "Select sound for question english",
    selectSoundForQuestion_ne: "Select sound for question netherlands",
    index: "Index",
    correct_answer: "Correct",
    answer_en: "Answer English",
    answer_ne: "Answer Netherlands",
    answer_in_number: "Answer (number)",
    question_part2_en: "Question part 2 in English",
    question_part2_ne: "Question part 2 in Netherlands",
    sort: "Sort",
    selectImageForAnswer: "Select image for answer",
    radioboxImg: "Multiple answer with one correct answer - image",
    checkboxImg: "Multiple answer with multiple correct answer - image",
    weight: "weight",
    yes: "بله",
    categories: "Categories",
    deleteCategoryMsg: "Do you want remove this category?",
    deleteQuestion: "Do you want remove this question?",
    editQuestion: "Edit question",

    categoryList: "Category List",
    addCategory: "Add Category",
    editCategory: "Edit Category",
    addNewLesson: "Add New Lesson",
    lessons: "Lessons",
    cancel: "لغو",
    addNewCategory: "Add new category",
    deleteLesson: "Do you want remove this lesson?",
    editLesson: "Edit Lesson",
    fillAllInputs: "لطفا تمام فیلد هارا وارد نمایید",
    submit: "Submit",
    category: "Category",
    questions: "Questions",
    addQuestion: "Add Question",
    questionsList: "Question List",
    packagesList: "Packages List",
    packages: "Packages",
    addNewPackage: "Add Package",
    lesson: "Lesson",
    month: "ماه",
    show: "show",
    dontShow: "Dont Show",
    remove: "Remove",
    users: "کاربران",
    usersList: "Users List",
    addUser: "اضافه کردن کاربر",
    deleteUser: "Delete User",
    priceId: "Price id from stripe.com",
    productId: "Product id from Apple Store",
    date_register: "Date register",
    passwordHelperText:
      "if only you want to change the user password fill this input",
    reports: "Reports",
    PaymentStatus: "Payment Status",
    paid: "Paid",
    unpaid: "Unpaid",
    package: "Package",
    bank: "بانک",
    date: "تاریخ",
    date_added: "Added Date",
    price_id: "Price ID",
    userName: "User Name",
    userEmail: "User Email",
    payment: "Payment",
    activationState: "Activation State",
    monthly: "Monthly",
    daily: "daily",
    description_en: "Description English",
    description_ne: "Description Netherlands",
  },

  fa: {
    dashboard: "داشبورد",
    sendOtp: "ارسال رمز یکبار مصرف",
    required_image: "انتخاب عکس الزامی می باشد",
    enter_one_of_the_prices: "فقط یکی از قیمت هارا وارد نمایید",
    signInWithOtp: "ورود با رمز یکبار مصرف",
    mobileOrEmail: "موبایل یا ایمیل",
    mobile: "موبایل",
    email: "ایمیل",
    signIn: "ورود به حساب کاربری",
    password: "رمز عبور",
    login: "ورود",
    pleaseWait: "لطفا منتظر بمانید...",
    tryAgain: "دوباره تلاش کنید",
    required: "وارد کردن این فیلد اجباری است",
    exist: "خروج",
    notExist: "ناموجود",
    noRecordFound: "اطلاعاتی یافت نشد",
    otp: "کد ارسال شده",
    CreateAnAccount: "ایجاد حساب کاربری",
    AlreadyHaveAnAccount: "حساب کاربری دارید؟",
    SignInHere: "ورود به حساب کاربری",
    fullName: "نام و نام خانوادگی",
    companyName: "شرکت",
    passwordTooltip:
      "رمزعبور قوی شامل 8 کارکتر، حروف کوچک و بزرگ، اعداد، کارکترهای خاص است",
    ConfirmPassword: "تکرار رمزعبور",
    singUp: "ثبت نام",
    PasswordsMustMatch: "تکرار رمزعبور صحیح نیست",
    otp_min: "کد ارسالی 4 رقمی است",
    invalidEmail: "ایمیل به درستی وارد نشده است",
    activeMobile: "تایید شماره همراه",
    accept: "تایید",
    acceptRoles: "باید قوانین و مقررات را بپذیرید",
    sendCode: "ارسال کد",
    servicesPackage: "سرویس ها",
    servicesList: "لیست سرویس ها",
    addService: "اضافه کردن سرویس",
    editService: "ویرایش سرویس",
    title: "عنوان",
    active: "فعال",
    deactivate: "غیر فعال",
    created_at: "تاریخ ایجاد",
    actions: "عملیات",
    name: "نام",
    searchTxt: "جستجو",
    search: "جستجو",
    back: "بازگشت",
    type: "نوع",
    google_ads: "تبلیغ در گوگل",
    youtube_ads: "تبلیغ در یوتیوب",
    facebook_ads: "تبلیغ در فیسبوک",
    discovery_ads: "تبلیغات دیسکاوری",
    banner_google: "تبلیغات بنری گوگل",
    banner_google_play: "تبلیغ در گوگل پلی استور",
    all: "همه",
    filterByType: "فیلتر بر اساس نوع",
    selectImage: "انتخاب عکس",
    price_usd: "قیمت به دلار",
    price_aed: "قیمت به درهم",
    activeOrDeactivate: "فعال / غیر فعال",
    price_usd_tooltip:
      "برای هر سرویس فقط قیمت دلار یا فقط قیمت درهم را وارد کنید در غیر اینصورت قیمت دلار محاسبه می شود",
    settings: "تنظیمات",
    range_price: "رنج قیمت دلار و درهم",
    from: "از",
    to: "تا",
    percent_or_price: "درصد یا مبلغ",
    percent: "درصد",
    cash: "مبلغ",
    save: "ذخیره",
    range_aed: "رنج قیمت برای درهم",
    range_usd: "رنج قیمت برای دلار",
    users: "کاربران",
    usersList: "لیست کاربران",
    addUser: "اضافه کردن کاربر",
    editUser: "ویرایش کاربر",
    yes: "بله",
    month: "ماه",
    bank: "بانک",
    date: "تاریخ",
    invoices: "فاکتور ها",
    invoicesList: "لیست فاکتور ها",
    searchInvoice: "جستجوی فاکتور",
    service_name: "نام سرویس",
    user: "کاربر",
    noName: "بدون نام",
    noPhone: "بدون موبایل",
    noEmail: "بدون ایمیل",
    payment_status: "وضعیت پرداخت",
    payment_paid: "پرداخت شده",
    payment_reserved_waiting_for_receipt_upload: "منتظر آپلود فیش",
    payment_not_paid: "پرداخت نشده",
    receipt_uploaded_waiting_for_operator_approval: "منتظر تایید",
    purchase_status: "وضعیت خرید",
    payement_type: "نوع پرداخت",
    renewal: "تمدید",
    purchase: "خرید",
    unknown_status: "نامشخض",
    final_price: "قیمت نهایی",
    tracking_code: "کد پیگیری",
    cart_to_cart: "کارت به کارت",
    download_invoice: "دانلود فاکتور",
    download: "دانلود",
    approve_invoice: "تایید فاکتور",
    view_details: "مشاهده جزییات",
    zarinpal: "زرین پال",
    invoice_accepted: "فاکتور با موفقیت تایید شد",
    invoice_accept_error: "مشکلی در تایید فاکتور پیش آمد",
    factor_id: "شناسه فاکتور",
    factor_details: "مشخصات فاکتور",
    status: "وضعیت",
    user_details: "مشخضات کاربر",
    code_meli: "کد ملی",
    service_details: "مشخصات سرویس",
    sevice_name: "نام سرویس",
    site: "سایت",
    key_word: "کلید واژه",
    currancy: "ارز پرداختی",
    pay_rate: "نرخ پرداختی",
    filter_by_paide_status: "فیلتر بر اساس وضعیت پرداخت",
    filter_by_service: "فیلتر بر اساس سرویس",
    all_services: "تمام سرویس ها",
    address: "آدرس",
    postal_code: "کد پستی",
    download_image: "دانلود عکس",
    logs: "لاگ ها",
    logs_list: "لیست لاگ ها",
    checked: "بررسی شده",
    un_checked: "بررسی نشده",
    status_changed_successfully: "وضعیت با موفقیت تغییر کرد",
    status_change_error: "مشکلی در تغییر وضعیت پیش آمد",
    settings_saved_succesfully: "تنظیمات با موفقیت ذخیره شد",
    Error_saving_settings: "مشکلی در ذخیره تنظیمات پیش آمد",
    save_Changes: "ذخیره تغییرات",
    arzesh_afzode: "ارزش افزوده",
    made_107: "مالیات تکلیفی",
    pro_manager: "درصد مدیریت اکانت",
    special_sheba: "شماره شبای کاربران ویژه",
    normal_sheba: "شماره شبای کاربران معمولی",
    change_currency: "تبدیل قیمت ارز به اسکناس",
    Enter_value: "مقدار را وارد نمایید",
    incoming_youtube: "نقد کردن درآمد یوتیوب",
    youtube_channels: "کانال های یوتوب",
    payments: "پرداخت ها",
    channel_name: "نام کانال",
    signature_by_user: "امضا شده توسط کاربر",
    pending: "در حال بررسی",
    reject: "رد شده",
    contract_percentage: "درصد کارکرد",
    end_cooperation: "پایان همکاری",
    end: "پایان همکاری",
    you_want_to_end_the_cooperation_with_this_channel:
      "می خواهید با این کانال قطع همکاری کنید ؟",
    you_want_to_accept_this_channel:
      "می خواهید وضعیت این کانال را به قبول شده تغییر بدهید؟",
    rejection_reason: "دلیل رد شدن",
    insert_the_reason_of_channel_rejection: "دلیل رد شدن کانال را وارد نمایید",
    error_rejectin_channel: "مشکلی در رد کردن کانال ایجاد شد",
    rejecting_channel_done_successfully: "رد کردن کانال با موفقیت انجام شد",
    close: " بستن",
    filter_by_status: "فیلتر بر اساس وضعیت",
    accepted: "قبول شده",
    search_channel_by_email_or_phone_of_the_user:
      "جستجوی کانال بر اساس موبایل یا ایمیل کاربر",
    download_contract: "دانلود قرارداد",
    contract: "قرارداد",
    invoices_list: "لیست فاکتور ها",
    invoice_creator: "ایجاد کننده فاکتور",
    deposit_price: "مبلغ واریزی",
    paid_date: "تاریخ پرداخت",
    income_information: "اطلاعات درآمد",
    percent_of_income: "درصد درآمد",
    income_in_dollars: "درآمد به دلار",
    plus: "اضافات",
    income_in_america: "درآمد از آمریکا",
    net_income: "درآمد پس از کسر مالیات و کارمزد",
    deposit_income: "واریز درآمد",
    pure_income: "درآمد خالص",
    dollar_price: "نرخ روز دلار",
    youtuber_bank_account: "حساب بانکی یوتوبر",
    sheba: "شماره شبا",
    add_invoice: "اضافه کردن فاکتور",
    error_adding_youtube_invoice: "مشکلی در ایجاد فاکتور یوتوب پیش آمد",
    adding_youtube_invoice_succesfully: "فاکتور یوتوب با موفقیت ایجاد شد",
    cancel: "لغو",
    create: "ایجاد",
    dateregister: "تاریخ ثبت نام",
    block: "مسدود",
    search_by_username_phone_email: "جستجو بر اساس نام - ایمیل - موبایل کاربر",
    block_user: "می خواهید این کاربر را بلاک نمایید؟",
    error_blocking_user: "مسدود کردن کاربر با مشکل مواجه شد",
    user_blocked_successfully: "کاربر با موفقیت بلاک شد",
    unblock_user: "می خواهید کاربر را آنبلاک کنید؟",
    error_unblocking_user: "مشکلی در آنبلاک کردن کاربر پیش آمد",
    user_unblocked_successfully: "کاربر با موفقیت آنبلاک شد",
    role: "نقش",
    company_name: "نام شرکت",
    state: "استان",
    person: "نوع شخص",
    special: "ویژه",
    owner_sheba: "صاحب شبا",
    wallet: "کیف پول",
    user_added_successFully: "کاربر با موفقیت اضافه شد",
    error_adding_user: "مشکلی در اضافه کردن کاربر پیش آمد",
    city: "شهر",
    natural: "حقیقی",
    legal: "حقوقی",
    select_person_type: "نوع شخص را انتخاب کنید",
    select_type: "حالت را انتخاب نمایید",
    normal: "معمولی",
    select_role: "نقش کاربر را انتخاب کنید",
    admin: "ادمین",
    operator: "اپراتور",
    password_min_length: "رمز عبور باید بیشتر از 8 کاراکتر باشد",
    success: "عملیات با موفقیت انجام شد",
    error: "عملیات انجام نشد",

    name_en: "English",
    name_ne: "Netherlands",
    question_en: "Question English",
    question_ne: "Question Netherlands",
    dragDropOne: "Drag & drop with one correct answer",
    dragDropMulti: "Drag & drop with multiple correct answers",
    radiobox: "Multiple answer with one correct answer",
    checkbox: "Multiple answer with multiple correct answer",
    blankOne: "Blank type one",
    blankTwo: "Blank type two",
    explain_en: "Explain English",
    explain_ne: "Explain Netherlands",
    selectImageForQuestion: "Select image for question",
    selectSoundForQuestion_en: "Select sound for question english",
    selectSoundForQuestion_ne: "Select sound for question netherlands",
    index: "Index",
    correct_answer: "Correct",
    answer_en: "Answer English",
    answer_ne: "Answer Netherlands",
    answer_in_number: "Answer (number)",
    question_part2_en: "Question part 2 in English",
    question_part2_ne: "Question part 2 in Netherlands",
    sort: "Sort",
    selectImageForAnswer: "Select image for answer",
    radioboxImg: "Multiple answer with one correct answer - image",
    checkboxImg: "Multiple answer with multiple correct answer - image",
    weight: "weight",
    categories: "Categories",
    deleteCategoryMsg: "Do you want remove this category?",
    deleteQuestion: "Do you want remove this question?",
    editQuestion: "Edit question",
    categoryList: "Category List",
    addCategory: "Add Category",
    editCategory: "Edit Category",
    addNewLesson: "Add New Lesson",
    lessons: "Lessons",
    addNewCategory: "Add new category",
    deleteLesson: "Do you want remove this lesson?",
    editLesson: "Edit Lesson",
    fillAllInputs: "Please fill inputs",
    submit: "Submit",
    category: "Category",
    questions: "Questions",
    addQuestion: "Add Question",
    questionsList: "Question List",
    packagesList: "Packages List",
    packages: "Packages",
    addNewPackage: "Add Package",
    lesson: "Lesson",
    show: "show",
    dontShow: "Dont Show",
    remove: "Remove",
    deleteUser: "Delete User",
    priceId: "Price id from stripe.com",
    productId: "Product id from Apple Store",
    date_register: "Date register",
    passwordHelperText:
      "if only you want to change the user password fill this input",
    reports: "Reports",
    PaymentStatus: "Payment Status",
    paid: "Paid",
    unpaid: "Unpaid",
    package: "Package",
    date_added: "Added Date",
    price_id: "Price ID",
    userName: "User Name",
    userEmail: "User Email",
    payment: "Payment",
    activationState: "Activation State",
    monthly: "Monthly",
    daily: "daily",
    description_en: "Description English",
    description_ne: "Description Netherlands",
    users_List: "لیست کاربران",
    ticket: "تیکت",
    departments: "دپارتمان ها",
    in_active: "غیر فعال",
    edit: "ویرایش",
    add_department: "اضافه کردن دپارتمان",
    edit_department: "ویرایش دپارتمان",
    department_edited_successfully: "دپارتمان با موفقیت ویرایش شد",
    error_editing_department: "مشکلی در ویرایش دپارتمان پیش آمد",
    department_added_successfully: "دپارتمان با موفقیت اضافه شد",
    error_adding_department: "مشکلی در اضافه کردن دپارتمان پیش آمد",
    department_activated: "دپارتمان با موفقیت فعال شد",
    department_deactivated: "دپارتمان با موفقیت غیر فعال شد",
    error_updating_department_status: "مشکلی در تغییر وضعیت دپارتمان پیش آمد",
    subject: "موضوع",
    department: "دپارتمان",
    open: "باز",
    closed: "بسته شده",
    in_progress: "در حال بررسی",
    answered: "پاسخ داده شده",
    tickets: "تیکت ها",
    send: "ارسال",
    type_your_text: "متن خود را وارد نمایید ",
    view: "مشاهده",
    error_closing_ticket: "مشکلی در بستن تیکت پیش آمد",
    ticket_closed_successfully: "تیکت با موفقیت بسته شد",
    search_ticket_by_email_or_phone_of_the_user:
      "جستجوی تیکت بر اساس موبایل یا ایمیل کاربر",
    you: "شما",
    edit_profile: "ویرایش پروفایل",
    profile: "پروفایل",
    profile_edited_successfully: "پروفایل با موفقیت ویرایش یافت",
    error_editing_profile: "مشکلی در ویرایش پروفایل پیش آمد",
    discount: "کد تخفیف",
    discountList: "لیست کد های تخفیف",
    code: "کد",
    service: "سرویس",
    date_end: "تاریخ پایان",
    used: "مصرف شده",
    add_discount: "اضافه کردن تخفیف",
    discount_code: "کد تخفیف",
    once: "یکبار مصرف",
    error_adding_discount: "مشکلی در اضافه کردن کد تخفیف پیش آمد",
    discount_added_successfully: "تخفیف با موفقیت اضافه شد",
    unused: "مصرف نشده",
    keywordPlanner: "کیورد پلنر",
    addKeywordPlanner: "اضافه کردن کیورد پلنر",
    keywordPlannerList: "لیست کیورد پلنر",
    price: "قیمت",
    day: "روز",
    add: "اضافه کردن",
    seller: "فروشنده",
    account_manager: "اکانت منیجر",
    export_invoice: "دریافت گزارش فاکتور",
    startDate: "تاریخ شروع",
    endDate: "تاریخ پایان",
    price_toman: "قیمت به تومان",
    exit: 'خروج',
    uncertain: 'نامشخص',
    accept_invoice: "تایید فاکتور",
    toman: "تومان",
    keyword_planner: "کیورد پلنر",
    reject_invoice: "رد فیش واریز",
    rejected: "رد شده",
    searchInUser: "جستجو بر اساس ایمیل و شماره موبایل کاربر",
    add_manual_invoice: "اضافه کردن فاکتور دستی",
    currency_paid: "ارز پرداخت شده توسط مشتری",
    service_currency: "نوع ارز سرویس",
    rial: 'ريال',
    tether: "تتر",
    aed: "درهم",
    usd: "دلار",
    service_price: "مبلغ شارژ اکانت",
    fee: "درصد کارمزد",
    rial_fee: "مبلغ ریالی کارمزد",
    currency_price: "نرخ ارز در هنگام ثبت خرید",
    withholding_tax: "مالیات تکلیفی",
    value_added_tax: "ارزش افزوده",
    which_service: "نوع سرویس خریداری شده",
    which_service_id: "سرویس خریداری شده",
    which_package_id: "پلن خریداری شده",
    type_mobile_or_email: "شماره موبایل یا ایمیل کاربر را وارد نمایید",
    type_more_five_char: "برای جستجو باید حداقل 6 کاراکتر وارد نمایید",
    not_found_user: "کاربر با این اطلاعات یافت نشد",
    rial_price: 'مبلغ ریالی شارژ',
    show_image: "نمایش تصویر",
    accounts_number: "شماره حساب ها",
    account_List: "حساب ها",
    addAccount: "اضافه کردن حساب",
    official: "رسمی",
    no_official: "غیر رسمی",
    currency: 'ارز',
    account: 'حساب',
    gbp: 'پوند',
    eur: 'یورو',
    network: 'شبکه',
    card: 'شماره کارت',
    description: 'توضیحات',
    current_cash: 'موجودی',
    editAccount: "ویرایش شماره حساب",
    filter_by_currency: "فیلتر بر اساس ارز",
    account_transactions: "انتقال پول",
    deposit: "واریز",
    withdrawal: "برداشت",
    transfer: "انتقال داخلی",
    new_transaction: "انتقال جدید",
    transactions_List: "لیست انتقال ها",
    source_account: "برداشت از حساب",
    destination_account: "واریز به حساب",
    amount: "مبلغ واریز یا برداشت",
    transfer_currency_price: "مبلغ ارز هنگام انتقال",
    negative_balance: "امکان منفی شدن موجودی وجود دارد",
    no: "خیر",
    error_insufficient_inventory: "موجودی حساب شما کمتر از مقدار انتقال است",
    account_source: "برداشت از",
    account_destination: "واریز به",
    transaction_date: "تاریخ واریز",
    addCounterpartyTransaction: "اضافه کردن طرف قرارداد",
    counterpartyTransactionList: "لیست طرف های قرارداد",
    counterparty_transaction: "طرف قرارداد",
    tracking_code_or_account: "کد رهگیری / حساب",
    financial: 'مالی',
    search_card: "جستجوی شماره کارت",
    search_sheba: "جستجوی شبا",
    search_account: "جستجوی شماره حساب",
    search_title: "جستجوی عنوان",
    search_cash: "جستجوی بر اساس موجودی",
    filter: "فیلتر",
    remove_filter: "حذف فیلتر",
    new_purchase: "خرید اکانت جدید",
  },
};

const i18n = createI18n({
  legacy: false,
  locale: "fa",
  globalInjection: true,
  messages,
});

export default i18n;
